import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Users, ShoppingBag, Calendar, Compass, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { TemplateCard } from '../components/TemplateCard';
interface TemplateCurationScreenProps {
  onNext: () => void;
  onBack: () => void;
}
export function TemplateCurationScreen({
  onNext,
  onBack
}: TemplateCurationScreenProps) {
  const [phase, setPhase] = useState<'question' | 'results'>('question');
  const handleGoalSelect = (goal: string) => {
    setTimeout(() => setPhase('results'), 300);
  };
  return <div className="min-h-screen flex flex-col p-6 pb-20 bg-[#0f0f2d]" data-id="element-141">
      <div className="flex-1 flex flex-col items-center justify-center max-w-6xl mx-auto w-full" data-id="element-142">
        <AnimatePresence mode="wait" data-id="element-143">
          {phase === 'question' ? <motion.div key="question" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: 20
        }} className="w-full max-w-4xl" data-id="element-144">
              <div className="text-center mb-12" data-id="element-145">
                <h2 className="text-4xl font-bold text-white mb-4" data-id="element-146">
                  What are you trying to do first?
                </h2>
                <p className="text-[#8b8bab]" data-id="element-147">
                  We'll curate the best templates for your goal.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-148">
                {[{
              id: 'leads',
              label: 'Collect leads',
              icon: Users
            }, {
              id: 'sell',
              label: 'Sell a product',
              icon: ShoppingBag
            }, {
              id: 'calls',
              label: 'Book calls',
              icon: Calendar
            }, {
              id: 'unsure',
              label: 'Not sure yet',
              icon: Compass
            }].map((option, idx) => <motion.button key={option.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: idx * 0.1
            }} onClick={() => handleGoalSelect(option.id)} className="flex items-center p-6 bg-[#1a1a3e] border border-[#2a2a5a] rounded-xl hover:border-[#ffc978] hover:bg-[#252550] transition-all group text-left" data-id="element-149">
                    <div className="p-3 bg-[#0f0f2d] rounded-lg text-[#8b8bab] group-hover:text-[#ffc978] group-hover:bg-[#ffc978]/10 transition-colors mr-4" data-id="element-150">
                      <option.icon size={24} data-id="element-151" />
                    </div>
                    <span className="text-lg font-medium text-white group-hover:text-white" data-id="element-152">
                      {option.label}
                    </span>
                  </motion.button>)}
              </div>
            </motion.div> : <motion.div key="results" initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} className="w-full" data-id="element-153">
              <div className="flex items-center justify-between mb-8" data-id="element-154">
                <div data-id="element-155">
                  <h2 className="text-3xl font-bold text-white mb-2" data-id="element-156">
                    Perfect. Here are some great starting points.
                  </h2>
                  <p className="text-[#8b8bab]" data-id="element-157">
                    High-converting templates optimized for your goal.
                  </p>
                </div>
                <Button variant="ghost" onClick={() => setPhase('question')} leftIcon={<ArrowLeft size={16} data-id="element-159" />} data-id="element-158">
                  Change Goal
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-160">
                <TemplateCard title="Squeeze Page Funnel" description="Simple 2-step funnel to capture email leads efficiently." imageColor="bg-[#a8c5e0]/20" onClick={onNext} delay={0.1} data-id="element-161" />
                <TemplateCard title="Reverse Squeeze Page" description="Give value first, then ask for the opt-in. Great for trust." imageColor="bg-[#c4a8e0]/20" onClick={onNext} delay={0.2} data-id="element-162" />
                <TemplateCard title="Lead Magnet Funnel" description="Exchange a free resource for contact information." imageColor="bg-[#a8e0c5]/20" onClick={onNext} delay={0.3} data-id="element-163" />
                <TemplateCard title="Bridge Page Funnel" description="Connect cold traffic to your core offer seamlessly." imageColor="bg-[#e0a8c5]/20" onClick={onNext} delay={0.4} data-id="element-164" />
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>

      {/* Back Button - Centered at Bottom (only show in question phase) */}
      {phase === 'question' && <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.4
    }} className="flex justify-center pt-8" data-id="element-165">
          <button onClick={onBack} className="flex items-center gap-2 text-[#5a5a7a] hover:text-white text-sm font-medium transition-colors" data-id="element-166">
            <ArrowLeft size={16} data-id="element-167" />
            Back
          </button>
        </motion.div>}
    </div>;
}